/**
 * Cell padding for RFI grids (Innovation Lab) and shared compact column constants
 * for assessment requests / Library Requests.
 */
export function getRfiGridCellPaddingClass(colIndex, totalCols, isHeader) {
  const py = isHeader ? "py-5" : "py-4";
  if (totalCols <= 1) {
    return `${py} pl-4 pr-4 sm:pl-6 sm:pr-6`;
  }
  const isFirst = colIndex === 0;
  const isLast = colIndex === totalCols - 1;
  if (isFirst) return `${py} pl-4 pr-2 sm:pl-6`;
  if (isLast) return `${py} pl-3 pr-4 sm:pr-6`;
  return `${py} px-2`;
}

/**
 * Widths and class names for compact columns (status, dates, cycle time, onsite/remote, multi-sponsor).
 * Aligned with `LibraryRequestsGridTable`; used in RFI and assessment request tables.
 */
export const COMPACT_GRID_COL_WIDTH_PCT = "4%";
export const compactGridStatusCellClassName = "max-w-[9rem]";
export const compactGridDateCellClassName =
  "text-center whitespace-nowrap max-w-[6.5rem]";
export const compactGridCycleCellClassName =
  "text-center whitespace-nowrap max-w-[7.5rem]";
export const compactGridOnsiteRemoteCellClassName =
  "text-center whitespace-nowrap max-w-[7rem]";
export const compactGridMultiSponsorCellClassName =
  "text-center whitespace-nowrap max-w-[4.5rem]";

/**
 * CustomTable `minWidth` for fixed-column grids (RFI, assessments, library requests).
 * Stops column headers and compact cells from overlapping on narrow viewports and high zoom; the
 * scroll region grows when the sum of minimum widths exceeds the container width.
 */
export const SIZE_TABLE_COL_MIN = {
  document_type_icon: "3.5rem",
  status: "5.75rem",
  date: "6.5rem",
  cycle: "6.5rem",
  published: "6.25rem",
  org: "8.5rem",
  document: "11rem",
  scope: "9.5rem",
  location: "8.5rem",
  type: "5.75rem",
  template: "8.5rem",
  actions: "2.25rem",
  onsiteRemote: "8.5rem",
  multiSponsor: "10.5rem",
  auditor: "8.5rem",
  requestType: "8rem",
};

/**
 * Optional `contentMaxWidth` for text-heavy columns: allows wrapping up to a reasonable line length.
 */
export const SIZE_TABLE_TEXT_COL_MAX = "18rem";
